import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import aboutOne from "../../images/aboutOne.jpg";
import aboutTwo from "../../images/aboutTwo.jpg";
import aboutThree from "../../images/aboutThree.jpg";
import aboutFour from "../../images/aboutFour.jpg";
const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;

const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
    {
      imageSrc: aboutTwo,
      subtitle: "Feel the Nostalgia with your buddies",
      title: "Live those days again",
      description:
        "The sound of the ball hitting the bat, Playing with friends, Making up rules and playing in unique locations, Playing cricket with friends is a common childhood memory that many people look back on with fondness. It was a time when friendships were formed and strengthened, and when the simple joy of playing a game together was enough to create lasting memories.",
      url: "https://timerse.com",
    },

    {
      imageSrc: aboutThree,
      subtitle: "Find your sports spirit",
      title: "Level up your Game",
      description:
        "We at Yorker Club-Club believe that sports have the power to transform lives and bring people together. Whether you're a seasoned athlete or just starting out, our mission is to help you discover your passion for sports and find the resources and support you need to succeed.",
      // url: "https://timerse.com",
    },
    {
      imageSrc: aboutFour,
      subtitle: "Practice ! Practice ! Practice !",
      title: "Mastering the Game: The Importance of Practice in Cricket",
      description:
        "Practice is an essential part, It allows players to hone their skills, improve their technique, and develop the mental and physical stamina needed to perform at the highest level.Regular practice can help players improve their strength, endurance, and agility, which can improve their performance on the field and reduce the risk of injury.",
      // url: "https://timerse.com",
    },
    {
      imageSrc: aboutOne,
      subtitle: "Dust Free",
      title: "Play all day long with Clean Environment",
      description:
        "Cleaning the box cricket area regularly is an important step towards maintaining good hygiene and reducing the risk of spreading germs and infections.",
      // url: "https://timerse.com",
    },
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>About Yorker Club</HeadingTitle>
          <HeadingDescription>
            Know more about Yorker Club, Cricket & Passion. Let's join
            us this weekend
          </HeadingDescription>
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
                {/* <Link href={card.url}>See Event Details</Link> */}
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
